module.exports = import("https://esm.sh/rita");;